import { registryComponent } from '@boost-sd/components-registry/registry';
import Button from '@components/Button';
import useTranslation from '@hooks/useTranslation';
import { createClsNameMap, mapModifiers } from '@utils';
import type { HTMLProps } from 'react';

export const clsNameMap = createClsNameMap({
  elements: {
    input: createClsNameMap(),
    'btn-wrapper': createClsNameMap(),
    btn: createClsNameMap(),
    error: createClsNameMap(),
  },
  modifiers: ['md', 'sm'],
})('input-number');

export type InputNumberProps = Omit<
  HTMLProps<HTMLInputElement>,
  'value' | 'defaultValue' | 'onChange' | 'size'
> & {
  error?: React.ReactNode;
  value: number | '';
  onChange: (value: number | '') => void;
  size?: 'sm' | 'md';
};

const InputNumber = ({ value, error, onChange, size = 'md', ...otherProps }: InputNumberProps) => {
  const { t } = useTranslation();

  const handleChangeQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target?.value === '' ? '' : Number(e.target.value));
  };

  const handleClickDecrease = () => {
    onChange(value === '' ? 1 : value > 1 ? value - 1 : 1);
  };

  const handleClickIncrease = () => {
    onChange(value === '' ? 1 : value + 1);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent input 'e', 'E', '+', '-', '.'
    return ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
  };

  return (
    <>
      <div className={mapModifiers(clsNameMap, [size])}>
        <div className={clsNameMap.elm('btn-wrapper')}>
          <Button
            className={clsNameMap.elm('btn')}
            onClick={handleClickDecrease}
            modifiers={['full-width']}
          >
            <span>-</span>
          </Button>
        </div>

        <input
          type='number'
          aria-label={t('cart.atcMiniCartItemQuantity')}
          value={value}
          className={clsNameMap.elm('input')}
          onChange={handleChangeQuantity}
          onKeyDown={handleOnKeyDown}
        />
        <div className={clsNameMap.elm('btn-wrapper')}>
          <Button
            className={clsNameMap.elm('btn')}
            onClick={handleClickIncrease}
            modifiers={['full-width']}
          >
            <span>+</span>
          </Button>
        </div>
      </div>
      {error}
    </>
  );
};

export default registryComponent('InputNumber', InputNumber);
